import { render } from "./OutLink.vue?vue&type=template&id=29559ff1&ts=true"
import script from "./OutLink.vue?vue&type=script&lang=ts"
export * from "./OutLink.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__